import React from 'react';
import PageBanner from '../components/PageBanner';
import { Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react';
import BookingForm from '../components/BookingForm';
import { useSettings } from '../context/SettingsContext';

const ContactPage = () => {
  const settings = useSettings();
  const raw = (settings.phone_raw || '').replace('+', '');
  return (
    <>
      <PageBanner
        title="Contact Get Nile Cruise"
        subtitle="Talk to a real Egypt Nile cruise expert — based in Aswan, available around the clock."
        image="https://images.unsplash.com/photo-1568503446072-5c1c17d9b018?crop=entropy&cs=srgb&fm=jpg&q=85"
        crumbs={[{ label: 'Contact' }]}
      />
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="font-serif text-[#304b71] text-3xl md:text-4xl">Get in touch</h2>
            <p className="mt-4 text-slate-600">Have a question about a specific ship, itinerary or Egypt tour? Send us a message and one of our specialists will reply within 24 hours — usually much faster.</p>

            <div className="mt-8 space-y-5">
              <div className="flex gap-4 p-5 border border-slate-100 rounded-2xl hover:border-[#6a8aa4] transition-colors">
                <div className="w-12 h-12 rounded-full bg-[#304b71] text-white flex items-center justify-center flex-shrink-0"><Phone size={20} /></div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#6a8aa4]">Call us</div>
                  <a href={`tel:${settings.phone_raw}`} className="font-serif text-xl text-[#304b71] hover:text-[#6a8aa4]">{settings.phone}</a>
                  <div className="text-xs text-slate-500 mt-1">24/7 for existing bookings</div>
                </div>
              </div>
              <div className="flex gap-4 p-5 border border-slate-100 rounded-2xl hover:border-[#6a8aa4] transition-colors">
                <div className="w-12 h-12 rounded-full bg-[#25D366] text-white flex items-center justify-center flex-shrink-0"><MessageCircle size={20} /></div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#6a8aa4]">WhatsApp</div>
                  <a href={`https://wa.me/${raw}`} target="_blank" rel="noreferrer" className="font-serif text-xl text-[#304b71] hover:text-[#6a8aa4]">Chat instantly</a>
                  <div className="text-xs text-slate-500 mt-1">Fastest way to reach us</div>
                </div>
              </div>
              <div className="flex gap-4 p-5 border border-slate-100 rounded-2xl hover:border-[#6a8aa4] transition-colors">
                <div className="w-12 h-12 rounded-full bg-[#304b71] text-white flex items-center justify-center flex-shrink-0"><Mail size={20} /></div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#6a8aa4]">Email</div>
                  <a href={`mailto:${settings.email}`} className="font-serif text-xl text-[#304b71] hover:text-[#6a8aa4]">{settings.email}</a>
                  <div className="text-xs text-slate-500 mt-1">Reply within 24 hours</div>
                </div>
              </div>
              <div className="flex gap-4 p-5 border border-slate-100 rounded-2xl hover:border-[#6a8aa4] transition-colors">
                <div className="w-12 h-12 rounded-full bg-[#304b71] text-white flex items-center justify-center flex-shrink-0"><MapPin size={20} /></div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#6a8aa4]">Office</div>
                  <div className="font-serif text-xl text-[#304b71]">{settings.address}</div>
                  <div className="text-xs text-slate-500 mt-1">Visit our Aswan office</div>
                </div>
              </div>
              <div className="flex gap-4 p-5 border border-slate-100 rounded-2xl">
                <div className="w-12 h-12 rounded-full bg-[#a6b2b5] text-[#304b71] flex items-center justify-center flex-shrink-0"><Clock size={20} /></div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#6a8aa4]">Office Hours</div>
                  <div className="font-serif text-lg text-[#304b71]">Sun – Thu: 9:00 – 20:00</div>
                  <div className="text-slate-500 text-sm">Fri – Sat: 10:00 – 16:00</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-[#f6f8fa] rounded-2xl p-8 border border-slate-100">
              <h3 className="font-serif text-[#304b71] text-2xl mb-2">Send us a message</h3>
              <p className="text-slate-600 text-sm mb-6">Fill out the form below and we'll get back to you within 24 hours.</p>
              <BookingForm defaultSubject="General Contact Inquiry" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
